import React, { Suspense, useContext, useEffect, useState } from 'react';
import Redis from 'ioredis';
import MobileDetect from 'mobile-detect';
import dynamic from 'next/dynamic';

import * as appContext from '../../components/AppContext';
import Checkers from '../../helpers/class/Checkers';
import * as DataFetchHelper from '../../helpers/DataFetchHelper';
import * as MethodHelper from '../../helpers/MethodHelper';

const Articles = dynamic( () => import( '../../components/templates/articles' ), { suspense: true });
import { Fancybox } from '@fancyapps/ui/dist/fancybox.esm';

import { fetchBlogContentData } from '../../helpers/DataFetchHelper';
import { setPageId } from '../../redux/actions';
import { wrapper } from '../../redux/store';
import MainLayout from "../../layouts/MainLayout";

// import DedicatedWorkerClass from '../../utils/socketsWorkers/DedicatedWorkerClass';

export default function Blog ( props ) {

  const pageContext = useContext( appContext.page );
  pageContext.pageId = props.app_data.page_id;

  pageContext.isMobile = props.isMobile;
  pageContext.isTablet = props.isTablet;
  pageContext.isDesktop = props.isDesktop;

  pageContext.appSettings = props.app;

  const [ urlHref, setUrlHref ] = useState( null );

  const domain = props.domain;
  const app_data = props.app_data;
  const app = props.app;
  const head = props.head;
  const footer = props.footer;

  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const rgbDesignColor = props.rgbDesignColor;
  const rgbSearchbarColor = props.rgbSearchbarColor;

  const isDesktop = props.isDesktop;
  const builder = Checkers.objChildExists( app, 'builder' ) ? app.builder : null;

  const image_fb_meta = Checkers.isValidArray( head.og_image ) ? head.og_image[0].image : null;

  const contactIcons = {
    phoneIcon: app.showPhoneIconOnMenu,
    chatIcon: app.showChatIconOnMenu,
    mailIcon: app.showMailIconOnMenu,
    phoneIconData: app.menuPhoneIconData,
    chatIconData: app.menuChatIconData,
    mailIconData: app.menuMailIconData
  }

  useEffect( function () {
    if ( window !== undefined ) {
      window.designMode = app.designMode;
      setUrlHref( window.location.href + '/' );
    }
    Fancybox.bind( "[data-fancybox]", {
      Image: {
        zoom: false,
      },
    });
  }, [ urlHref, app.designMode ]);
  return (
      <MainLayout {...props}>
        <Suspense>
          <div id="articles_top"/>
          <Articles
            type={'blog'}
            domain={domain}
            app_data={app_data}
            app={app}
            head={head}
            footer={footer}
            locations={locations}
            navigation={navigation}
            content={content.content}
            articlesCategories={content.articles_categories}
            rgbDesignColor={rgbDesignColor}
            rgbSearchbarColor={rgbSearchbarColor}
            isDesktop={isDesktop}
            image_fb_meta={image_fb_meta}
            contactIcons={contactIcons}
            urlHref={urlHref}
            builder={builder}
            htmlSections={props.html_sections}
          />
        </Suspense>
      </MainLayout>
  )
}



// export async function getServerSideProps ({ req, res }) {
export const getServerSideProps = wrapper.getServerSideProps( ( store ) => async (
  { req,
    res,
    query
  }) => {

  const [ isMobile, isTablet,  isDesktop ] = Checkers.getUserAgentData( store, req )

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=43200, stale-while-revalidate=60'
  )
  const redis = new Redis( process.env.REDIS );
  let subdomain = null;
  const slug_data = null;

  let head = null;
  let app = null;
  let page = null;
  let app_data = null;
  let navigation = null;
  let content = null;
  let locations = null;
  let footer = null;
  let rgbSearchbarColor = null;
  let rgbDesignColor = null;
  let manifest = null;
  let html_sections;

  const domain = req.headers.host;
  const hostname_parts = req.headers.host.split( '.' );
  const parts = hostname_parts.length;

  app_data = await DataFetchHelper.fetchAppData( req, redis, res );

  store.dispatch( setPageId( app_data.page_id ) )

  if ( app_data != null ) {

    await DataFetchHelper.fetchSystemData( redis, app_data.page_id, store ).then( ( response ) => {
      head = response.head
      app = response.app
      page = response.page
      navigation = response.navigation
      locations = response.locations
      footer = response.footer
      html_sections = response.html_sections
    })

    content = await DataFetchHelper.fetchBlogContentData( redis, app_data.page_id )
  }

  manifest = MethodHelper.initManifest( head, app, '../../?source=pwa' );
  manifest = MethodHelper.extendManifest( manifest, head );

  const json = JSON.stringify( manifest );
  const fs = require( 'fs' );
  fs.writeFile( './public/manifest.json', json, ( err ) => {
    if ( err ) {
      redis.disconnect(false)

      // eslint-disable-next-line no-console
      console.error( err )
      return
    }
  });

  if ( app != null && app.searchbarBgColor != null )
    rgbSearchbarColor = MethodHelper.hexToRgb( app.searchbarBgColor );
  if ( app != null && app.designColor )
    rgbDesignColor = MethodHelper.hexToRgb( app.designColor );

  redis.disconnect(false)

  return {
    props: {
      app_data: app_data,
      head: head,
      page: page != null ? page.page : null,
      app: app,
      builder: app != null && app.builder != null ? app.builder : null,
      navigation: navigation,
      content: content,
      locations: locations,
      footer: footer,
      domain: domain,
      subdomain: subdomain,
      parts: parts,
      html_sections: html_sections,
      slug_data: slug_data,
      rgbDesignColor: rgbDesignColor,
      rgbSearchbarColor: rgbSearchbarColor,
      isDesktop: isDesktop
    }
  }
})
